<div class="dashboard-header">
  <div class="dashboard-info">
    <h2>Rulesets</h2>
    <p>
      Rulesets define how the BeExpert Proctoring SDK enforces integrity. Create custom rulesets or manage the defaults.
    </p>
  </div>

  <button
    type="button"
    class="add-assessment-btn"
    (click)="openRuleSet()"
    *hasPermission="PermissionForStudents.PROCTORING_CREATE"
  >
    <i class="bi bi-plus-lg"></i>
    Add Ruleset
  </button>
</div>

<ng-container *ngIf="isInitialLoad; else showPage">
  <div class="app-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-template #showPage>
  <ng-container *ngIf="ruleData.length > 0 || searchText; else showMessage">
<hr class="dashboard-divider" />
<div class="table-wrapper">
  <div class="table-filters">
    <div class="search-row">
      <div class="search-box">
        <i class="fa fa-search" *ngIf="!searchText"></i>
        <i *ngIf="searchText" class="bi bi-x" (click)="searchText = ''; onSearchChange()" style="cursor: pointer; font-size: 1.2rem; z-index: 10;"></i>
        <input
          type="text"
          placeholder="Search by ruleset by name..."
          [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange()"
        />
      </div>
    </div>
  </div>

  <div class="report-table">
    <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th>
            Ruleset Name
            <span class="material-icons sort-icon" (click)="sortBy('name')"> swap_vert </span>
          </th>

          <th>
            Purpose
            <span class="material-icons sort-icon" (click)="sortBy('description')"> swap_vert </span>
          </th>

          <th>
            Total rules
            <!-- <span class="material-icons sort-icon" (click)="sortBy('totalRules')"> swap_vert </span> -->
          </th>

          <th>
            Last updated
            <span class="material-icons sort-icon" (click)="sortBy('updatedAt')"> swap_vert </span>
          </th>

          <th>
            Created on
            <span class="material-icons sort-icon" (click)="sortBy('createdAt')"> swap_vert </span>
          </th>

          <th>
            Actions
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngIf="isLoading">
          <td colspan="6" style="padding: 40px 0; text-align: center;">
            <mat-spinner diameter="50" style="margin: 0 auto;"></mat-spinner>
          </td>
        </tr>
        <ng-container *ngIf="!isLoading && ruleData.length > 0">
        <tr *ngFor="let rules of ruleData">
          <td>
            <span [matTooltip]="rules.name">
            {{ (rules.name || '').length > 20 ? ((rules.name || '') | slice:0:20) + '...' : rules.name || '-' }}
         <ng-container *ngIf="rules.id === defaultRuleSetId">
            <span class="default-badge">Default</span>
          </ng-container>
            </span>
          </td>

          <td>
             <span [matTooltip]="rules.description">
            {{ (rules.description || '').length > 30 ? ((rules.description || '') | slice:0:30) + '...' : rules.description  || '-'}}
            </span>
          </td>

          <td>
              {{ rules.totalRules || '-' }}
          </td>
          <td>
            {{ rules.updatedAt | date: 'dd MMM yyyy' }}
          </td>
          <td>
            {{ rules.createdAt | date :'dd MMM yyyy' }}
          </td>

          <td class="action-cell">
            <!-- <ng-container *hasPermission="PermissionForStudents.PROCTORING_READ">
            <a class="view-report" (click)="goToRulesetPage(rules.id)">
              <i class="bi bi-eye"></i>
              View
            </a>
           </ng-container>  -->

            <ng-container *hasPermission="PermissionForStudents.PROCTORING_UPDATE">
            <span class="ms-3" (click)="goToRulesetEditPage(rules.id)">
              <i class="bi bi-pencil"></i>
              Edit
            </span>
            </ng-container>

              <ng-container *hasPermission="PermissionForStudents.PROCTORING_DELETE">
              <span class="ms-3" (click)="openDeleteDialogBox(rules.id , rules.name)" *ngIf="rules.id !== defaultRuleSetId">
            <i class="bi bi-trash"></i>
              Delete
            </span>
            </ng-container>

          </td>
        </tr>
        </ng-container>
        <tr *ngIf="!isLoading && ruleData.length === 0">
          <td colspan="6">
            <div class="empty-state" style="padding: 40px; text-align: center; color: #64748b; font-size: 14px;">
              No result found with this name. Please try searching with another name.
            </div>
          </td>
        </tr>
      </tbody>
    </table>
      </div>

    <div class="table-pagination" *ngIf="ruleData.length > 0">
      <div class="pagination-left">
        Showing <b>{{ startRecord }}</b>–<b>{{ endRecord }}</b> of <b>{{ total }}</b>

        <span>Rows per page</span>

        <select [(ngModel)]="pageSize" (change)="changePageSize()">
  <option [ngValue]="5">5</option>
  <option [ngValue]="10">10</option>
  <option [ngValue]="25">25</option>
  <option [ngValue]="50">50</option>
</select>
      </div>

      <div class="pagination-right">
        <button [disabled]="currentPage === 1"
          (click)="previousPage()">Previous</button>

        <span> Page 
          <select [(ngModel)]="currentPage" (ngModelChange)="goToPage($event)">
            <option *ngFor="let page of pagesArray" [ngValue]="page">{{ page }}</option>
          </select>
          of {{ displayTotalPages }} 
        </span>

        <button [disabled]="currentPage === totalPages"
          (click)="nextPage()">Next</button>
      </div>
    </div>
  </div>
</div>
</ng-container>
<ng-template #showMessage>
  <div class="empty-state" style="padding: 40px; text-align: center; color: #64748b; font-size: 14px;">
    No Ruleset available
  </div>
</ng-template>
</ng-template>